import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const TeamInvitationCard = ({ invitation, onAccept, onDecline, onMessage }) => {
  const [isProcessing, setIsProcessing] = useState(false);

  const handleAccept = async () => {
    setIsProcessing(true);
    try {
      await onAccept(invitation?.id);
    } finally {
      setIsProcessing(false);
    }
  };

  const handleDecline = async () => {
    setIsProcessing(true);
    try {
      await onDecline(invitation?.id);
    } finally {
      setIsProcessing(false);
    }
  };

  const getTimeAgo = (timestamp) => {
    const now = new Date();
    const inviteTime = new Date(timestamp);
    const diffInMinutes = Math.floor((now - inviteTime) / (1000 * 60));
    
    if (diffInMinutes < 60) return `${diffInMinutes}m ago`;
    if (diffInMinutes < 1440) return `${Math.floor(diffInMinutes / 60)}h ago`;
    return `${Math.floor(diffInMinutes / 1440)}d ago`;
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 hover:shadow-soft transition-micro">
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-center space-x-3">
          <Image
            src={invitation?.sender?.avatar}
            alt={`${invitation?.sender?.name}'s profile`}
            className="w-10 h-10 rounded-full object-cover"
          />
          <div>
            <h4 className="font-medium text-foreground">{invitation?.sender?.name}</h4>
            <p className="text-sm text-muted-foreground">{invitation?.sender?.role}</p>
          </div>
        </div>
        <span className="text-xs text-muted-foreground">{getTimeAgo(invitation?.timestamp)}</span>
      </div>
      <div className="mb-3">
        <p className="text-sm text-foreground mb-2">{invitation?.message}</p>
        {invitation?.teamName && (
          <div className="flex items-center space-x-2 text-sm text-muted-foreground">
            <Icon name="Users" size={14} />
            <span>Team: {invitation?.teamName}</span>
          </div>
        )}
      </div>
      {invitation?.problemStatement && (
        <div className="mb-3 p-3 bg-muted rounded-lg">
          <p className="text-sm font-medium text-foreground mb-1">Problem Statement:</p>
          <p className="text-sm text-muted-foreground line-clamp-2">
            {invitation?.problemStatement}
          </p>
        </div>
      )}
      <div className="flex items-center space-x-2">
        <Button
          variant="default"
          size="sm"
          onClick={handleAccept}
          loading={isProcessing}
          iconName="Check"
          iconPosition="left"
          iconSize={14}
          className="flex-1"
        >
          Accept
        </Button>
        
        <Button
          variant="outline"
          size="sm"
          onClick={handleDecline}
          loading={isProcessing}
          iconName="X"
          iconPosition="left"
          iconSize={14}
          className="flex-1"
        >
          Decline
        </Button>
        
        <Button
          variant="ghost"
          size="icon"
          onClick={() => onMessage(invitation?.sender?.id)}
          className="shrink-0"
        >
          <Icon name="MessageSquare" size={16} />
        </Button>
      </div>
    </div>
  );
};

export default TeamInvitationCard;